import { render, staticRenderFns } from "./SidebarRight.vue?vue&type=template&id=5babed3f&"
import script from "./SidebarRight.vue?vue&type=script&lang=js&"
export * from "./SidebarRight.vue?vue&type=script&lang=js&"
import style0 from "./SidebarRight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports